import { createContext, useContext } from "react";
import { AlertStore } from "./Alert.store";
import { TranslationStore } from "./Translation.store";

export class RootStore {
  $alertStore = new AlertStore();
  $translationStore = new TranslationStore();
}

export const RootStoreContext = createContext(new RootStore());

export const useRootStore = () => useContext(RootStoreContext);
